import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, Protected } from "./lib/auth";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Investors from "./pages/Investors";
import Opportunities from "./pages/Opportunities";
import Distressed from "./pages/Distressed";
import PropertyDetail from "./pages/PropertyDetail";
import Sell from "./pages/Sell";
import PropertyManagement from "./pages/PropertyManagement";
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import Market from "./pages/Market";
import Login from "./pages/Login";
import Brand from "./pages/Brand";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/investors" element={<Investors />} />
            <Route path="/opportunities" element={<Opportunities />} />
            <Route path="/opportunities/:slug" element={<PropertyDetail />} />
            <Route path="/distressed" element={<Distressed />} />
            <Route path="/sell" element={<Sell />} />
            <Route path="/property-management" element={<PropertyManagement />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/legal/:slug" element={<Legal />} />
            <Route path="/markets/:slug" element={<Market />} />
            <Route path="/login" element={<Login />} />
            <Route path="/brand" element={<Brand />} />
            <Route path="/dashboard" element={<Protected role="investor"><Dashboard /></Protected>} />
            <Route path="/admin" element={<Protected role="admin"><Admin /></Protected>} />
            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
